import { useTranslation } from 'react-i18next';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { useGlobals } from 'src/shared/contexts/appContext';
import { HELP_BUTTON_ID, HELP_PANEL_ID } from './helpPanel';

/**
 * Den flytande knappen nere till höger som öppnar hjälppanelen. Den döljs medan panelen är öppen, eftersom panelen
 * täcker hörnet; panelen stängs med sitt X eller med Esc.
 */
export const HelpPanelButton = () => {
  const { t } = useTranslation(['common']);
  const { helpPanelOpen, setHelpPanelOpen } = useGlobals();
  const theme = useTheme();
  // Bara ikonen på mobil, så att knappen täcker så lite som möjligt. noSsr: rätt form direkt, utan att den breda
  // knappen syns ett ögonblick först.
  const iconOnly = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <Zoom in={!helpPanelOpen}>
      <Fab
        id={HELP_BUTTON_ID}
        variant={iconOnly ? 'circular' : 'extended'}
        color='primary'
        onClick={() => setHelpPanelOpen(true)}
        aria-label={iconOnly ? t('common:helpButtonText') : undefined}
        aria-expanded={helpPanelOpen}
        aria-controls={HELP_PANEL_ID}
        sx={{ position: 'fixed', right: 24, bottom: 24, textTransform: 'none' }}
      >
        <HelpOutline sx={{ mr: iconOnly ? 0 : 1 }} />
        {!iconOnly && t('common:helpButtonText')}
      </Fab>
    </Zoom>
  );
};
